import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  CompanyBrandingModel,
  ICPLAuthCompanyBrandingClient,
  LoginScreenNarrativeModel,
} from "./api/cplauthapi/CPLAuthAPI";

export interface ICompanyBrandingService {
  getCompanyBranding(host: string): Promise<CompanyBrandingModel>;
  getLoginScreenNarrative(companyID: string): Promise<LoginScreenNarrativeModel>;
}

@injectable()
export class CompanyBrandingService implements ICompanyBrandingService {
  @inject(SERVICE_TYPES.CPLAuthCompanyBrandingClient) cplAuthCompanyBrandingClient!: ICPLAuthCompanyBrandingClient;

  getCompanyBranding(companyID: string): Promise<CompanyBrandingModel> {
    return this.cplAuthCompanyBrandingClient.getCompanyBrandingForCompany(companyID);
  }

  getLoginScreenNarrative(companyID: string): Promise<LoginScreenNarrativeModel> {
    return this.cplAuthCompanyBrandingClient.getCompanyLoginScreenNarrativeForCompany(companyID);
  }
}
